'use client';

import { twMerge } from 'tailwind-merge';
import { socialIcons } from '../../../utils/socials';
import { appConfig } from '../../../config';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Share from '../../components/svg/socials/Share';
import { createPortal } from 'react-dom';
import Close from '../../components/svg/Close';
import CopyLink from '../../components/svg/socials/CopyLink';



export default function SocialsShareMobile({className, postId}: {className?: string; postId: string}) {
  const socials = socialIcons.filter(s => ![1,4,5, 8, 10, 11, 12].includes(s.type));
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef<any>();
  const btnRef = useRef<any>();

  const handleClick = (e: any) => {
    if (ref.current && !ref.current.contains(e.target) && !btnRef.current.contains(e.target)) setShow(false);
  }

  useEffect(() => {
    window.addEventListener('mousedown',handleClick);
    return () => {
      window.removeEventListener('mousedown', handleClick);
    }
  },[]);

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 1.5 * 1000);
  }

  return (
    <div className='w-fit relative tablet:hidden'>
      <div  ref={btnRef} className={twMerge('grid tablet:hidden place-items-center aspect-square h-[40px] p-[8px] rounded-[4px] bg-gray-0 dark:bg-quaternary')} onClick={() => setShow(!show)}>

    <Share/>
      </div>
        <div className={twMerge('h-[40px] absolute hidden items-center top-0 left-full px-[6px] border border-gray-0 dark:border-lightBorder rounded-[12px] bg-white dark:bg-quaternary', show && 'flex')} ref={ref}>
          {/* <Close className='h-[18px] w-[18px] [&>*]:fill-black dark:[&>*]:fill-white' onClick={() => setShow(false)}/> */}
        <div className={twMerge('flex justify-center w-full gap-[24px] desktop:gap-[16px] desktop:py-[24px] [&>*]:grid [&>*]:place-items-center [&>*]:rounded-[4px] [&>*]:[&>*]:h-[28px] [&>*]:[&>*]:w-[28px] [&>*]:cursor-pointer', className)}>
          <div className={twMerge('grid place-items-center h-fit w-fit relative')}>
            <CopyLink className='[&>*]:!w-[28px] [&>*]:!h-[28px]' onClick={() => copied ? undefined : handleCopy()} />
            {copied ? <div className='absolute left-0 top-0 !w-fit translate-y-[-36px] sm text-gray-1000 dark:text-white py-[2px] px-[5px] bg-gray-0 dark:bg-lightBorder rounded-[4px] h-fit grid place-items-center overflow-visible'><span>نسخ</span></div> : null}
          </div>
          {socials.map(({ShareComponent,getShareLink,type, title}, i) => <Link title={title} key={type} target='_blank' href={getShareLink(`${appConfig.NEXT_PUBLIC_BASE_URL}/${postId}`)}><ShareComponent keepOriginal className='[&>*]:h-full [&>*]:w-full'/></Link>)}
        </div>
        </div>
    </div>
  )
}